import type { HslToRgb } from "./types";

export const hslToRgb: HslToRgb = ({ hue, saturation, lightness }) => {
  const chroma = (1 - Math.abs(2 * lightness - 1)) * saturation;
  const huePrime = hue / 60;
  const secondaryComponent = chroma * (1 - Math.abs((huePrime % 2) - 1));
  const matchValue = lightness - chroma / 2;

  let red = 0;
  let green = 0;
  let blue = 0;

  if (huePrime < 1) {
    red = chroma;
    green = secondaryComponent;
  } else if (huePrime < 2) {
    red = secondaryComponent;
    green = chroma;
  } else if (huePrime < 3) {
    green = chroma;
    blue = secondaryComponent;
  } else if (huePrime < 4) {
    green = secondaryComponent;
    blue = chroma;
  } else if (huePrime < 5) {
    red = secondaryComponent;
    blue = chroma;
  } else {
    red = chroma;
    blue = secondaryComponent;
  }

  return [
    Math.round((red + matchValue) * 255),
    Math.round((green + matchValue) * 255),
    Math.round((blue + matchValue) * 255),
  ];
};
